<template>
  <div class="reauth-card">
    <div class="reauth-wrapper">
      <div class="icon-wrapper">
        <unicon name="exclamation-triangle"></unicon>
      </div>
      <div class="info-wrapper">
        <h3>Reconnect Zendesk</h3>
        <p>Re-authenticate to continue using the app</p>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-small btn-primary"
      @click="reAuthenticate"
    >
      Reconnect Zendesk
    </button>
  </div>
</template>

<script>
export default {
  name: "ReAuthCard",
  methods: {
    reAuthenticate() {
      this.$router.push({ path: "/zendesk/connection" });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.reauth-card {
  padding: 1.5rem;
  background: lighten($redColor, 38.5%);
  border: 1px solid darken($redColor, 5%);
  border-radius: 1rem;
  margin-top: auto;
}

.icon-wrapper {
  display: flex;
  justify-content: center;

  ::v-deep svg {
    fill: darken($redColor, 25%);
    width: 1.75rem;
    height: 1.75rem;
  }
}

.info-wrapper {
  h3 {
    color: darken($redColor, 25%);
    font-size: $smallFontSize;
    margin-bottom: 0.25rem;
  }

  p {
    color: darken($redColor, 25%);
    font-size: $smallerFontSize;
    line-height: 1.4;
    margin-bottom: 0;
  }
}

.btn {
  display: block;
  width: 100%;
  margin-top: 1rem;
}

.reauth-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
}
</style>
